import { useEffect, useState } from "react";
import PropTypes from "prop-types";
import {
  FormControl,
  FormControlLabel,
  Grid,
  Radio,
  RadioGroup,
} from "@mui/material";
import Card from "../../components/Cards/Card";
import styled from "styled-components";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import NativeObject from "../../components/NativeObject/NativeObject";
import { useSelections } from "../../context/Selections";

const LayoutCardWrapper = styled.div`
  border-radius: 16px;
  display: flex;
  width: 100%;
  height: 100%;
  padding-right: 10px;
`;

const LayoutCardsWrapper = styled("div")({
  alignItems: "center",
  display: "flex",
  flexDirection: "column",
  height: "100%",
  justifyContent: "flex-start",
  width: "100%",
});

function DesafioDesktop({ app }) {
  return (
    <div className="app desafio">
      <div className="appContent">
        <LayoutCardsWrapper>
          <LayoutCardWrapper>
            <div className="group-cards">
              <Card
                app={app}
                header={{
                  hardTitle: "Desafio",
                }}
                style={{
                  width: "100%",
                  height: "100%",
                }}
                exportContainer
                exportTable
                exportTableId="jvgp"
              >
                <NativeObject
                  app={app}
                  key="jvgp"
                  reference={{ id: "jvgp" }}
                  style={{
                    width: "100%",
                    height: "100%",
                  }}
                />
              </Card>

              <Card
                app={app}
                header={{
                  hardTitle: "Detalhamento Desafio",
                }}
                style={{
                  width: "100%",
                  height: "100%",
                }}
                exportContainer
                exportTable
                exportTableId="TqXcxJ"
              >
                <NativeObject
                  app={app}
                  key="TqXcxJ"
                  reference={{ id: "TqXcxJ" }}
                  style={{
                    width: "100%",
                    height: "900px",
                  }}
                />
              </Card>
            </div>
          </LayoutCardWrapper>
        </LayoutCardsWrapper>
      </div>
    </div>
  );
}

DesafioDesktop.defaultProps = {
  app: null,
  config: {},
};

DesafioDesktop.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default DesafioDesktop;
